module.exports = __webpack_public_path__ + "img/ring.f0018837.png";